import Vue from "vue";
export async function fetchCountries({ commit }) {
  try {
    /*const { data } = await Vue.axios({
      url: '/pais',
      headers: { Authorization: `Bearer ${window.localStorage.getItem('_token')}` }
    })*/
    let res = await fetch(Vue.prototype.$apiRoute + "Localizacion/Paises", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      }
    });

    let data = await res.json();
    commit("setCountries", data);
  } catch (error) {
    commit("errorMessage", error.message);
  } finally {
    //console.log('La petición para obtener los países ha finalizado')
  }
}
